<template>
    <main class="mt-5">
        <div class="card mt-3">
            <div class="card-header  border-0">
                <h5 class="card-title font-bold py-3">جزئیات عملکرد فروشنده</h5>
                <div style="flex: 1"></div>
                <Back :url="`/admin/sales-management/reports/result-goods-sellers?start_date=${this.$route.query.start_date}&end_date=${this.filterDate.endDate}`" />
            </div>
            <!-- <div class="row px-4 not-in-print">
                <form autocomplete="new-password" @submit.prevent="doFilter"
                    class="col-12 d-flex justify-content-center align-items-center">

                    <div class="me-2">
                        <DatePickerRange v-model="filterDate" />
                    </div>

                    <button :disabled="disabled" type="submit" class="btn btn-info mr-5">
                        اعمال فیلتر
                    </button>

                </form>
            </div> -->
            <div class="report-header-box my-4">
                <div class="seller-name">
                    {{ sellerName }}
                </div>

                <div class="date-range">
                    <div v-if="filterDate.startDate" class="ml-1">
                        <span>از</span>
                        <span class="date-label">تاریخ</span>
                        <span class="date-value">{{ filterDate.startDate | persianDate }}</span>
                    </div>

                    <div v-if="filterDate.endDate">
                        <span>تا</span>
                        <span class="date-label">تاریخ</span>
                        <span class="date-value">{{ filterDate.endDate | persianDate }}</span>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center mb-3 g-3">
                <Loading class="mb-5" v-if="loading" />
                <div v-else-if="reports" class="col-12 col-md-auto">
                    <div class="row justify-content-center text-center g-3 mt-2">
                        <div class="col-12 col-md-auto d-flex justify-content-center">
                            <div class="report-item-card">
                                <span class="report-label">فروخته شده :</span>
                                <span class="report-label">{{ soldRequests.length }}</span>
                            </div>
                        </div>
                        <div class="col-12 col-md-auto d-flex justify-content-center">
                            <div class="report-item-card">
                                <span class="report-label">برگشت داده شده :</span>
                                <span class="report-label">{{ returnedRequests.length }}</span>
                            </div>
                        </div>
                        <div class="col-12 col-md-auto d-flex justify-content-center">
                            <div class="report-item-card">
                                <span class="report-label">نامشخص :</span>
                                <span class="report-label">{{ unknownRequests.length }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <p v-else>داده‌ای یافت نشد.</p>
            </div>
            <div v-if="reports" class="row p-4">
                <div class="col-12" v-if="soldRequests.length">
                    <hr>
                </div>
                <div class="p-5 col-12" v-if="soldRequests.length">
                    <h4 class="font-weight-bold">فروش رفته ها:</h4>
                    <b-table bordered striped :fields="soldRequestsFields" :items="soldRequests" responsive>
                        <template v-slot:cell(row)="data">
                            {{ data.index + 1 }}
                        </template>
                        <template v-slot:cell(created_at)="data">
                            {{ data.item.created_at | persianDate }}
                        </template>
                        <template v-slot:cell(sold_at)="data">
                            {{ data.item.sold_at | persianDate }}
                        </template>
                    </b-table>
                </div>
                <div class="col-12" v-if="returnedRequests.length">
                    <hr>
                </div>
                <div class="p-5 col-12" v-if="returnedRequests.length">
                    <h4 class="font-weight-bold">برگشت داده شده به انبار:</h4>
                    <b-table bordered striped :fields="returnedRequestsFields" :items="returnedRequests" responsive>
                        <template v-slot:cell(row)="data">
                            {{ data.index + 1 }}
                        </template>
                        <template v-slot:cell(created_at)="data">
                            {{ data.item.created_at | persianDate }}
                        </template>
                        <template v-slot:cell(returned_at)="data">
                            {{ data.item.returned_at | persianDate }}
                        </template>
                    </b-table>
                </div>
                <div class="col-12" v-if="unknownRequests.length">
                    <hr>
                </div>
                <div class="p-5 col-12" v-if="unknownRequests.length">
                    <h4 class="font-weight-bold">نامشخص:</h4>
                    <b-table bordered striped :fields="unknownRequestsFields" :items="unknownRequests" responsive>
                        <template v-slot:cell(row)="data">
                            {{ data.index + 1 }}
                        </template>
                        <template v-slot:cell(created_at)="data">
                            {{ data.item.created_at | persianDate }}
                        </template>
                        <template v-slot:cell(edit_description)="data">
                            <button class="btn btn-sm btn-icon btn-warning text-white" @click="openModal(data.item.id)"
                                type="button" data-original-title="ویرایش">
                                <i class="fa fa-pencil"></i>
                            </button>
                        </template>
                    </b-table>
                </div>
            </div>
        </div>
        <div class="modal fade" id="editModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-md" role="document">
                <div class="modal-content modal-content-demo">
                    <div class="modal-header">
                        <p class="modal-title font-weight-bold">ویرایش توضیحات آیتم</p>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="submitEdit">
                            <div class="form-group">
                                <label for="description">توضیحات:</label>
                                <textarea v-model="editDescription" class="form-control" id="description">{{ editDescription
                            }}</textarea>
                            </div>
                            <input type="hidden" v-model="currentEditId" />
                            <div class="modal-footer justify-content-center">
                                <button type="button" class="btn btn-secondary" data-dismiss="modal">بستن</button>
                                <button type="submit" class="btn btn-primary">ذخیره</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import { BTooltip, BFormGroup, BTable, BFormInput, BFormCheckbox, BTd, VBToggle, VBTooltip } from "bootstrap-vue";
import DatePickerRange from "@@/core/components/shared/DatePickerRange/DatePickerRange";
import mixins from '@@/core/mixins/mixins'
import Loading from '@@/core/components/shared/Loading/Loading'
import Back from "@@/core/components/shared/Back/Back";

function Filter() {
    this.date = {
        startDate: "",
        endDate: "",
    };
}

Filter.prototype.set = function (filters) {
    Object.entries(filters).forEach(([index, value]) => {
        this[index] = value;
    });
};

export default {
    name: "ResultGoodsSellersDetail",
    mixins: [mixins],
    components: {
        DatePickerRange,
        BTable,
        Loading,
        BFormCheckbox,
        BFormGroup,
        BTooltip,
        Back,
        BTd,
        BFormInput,
    },
    directives: {
        'b-toggle': VBToggle, 'b-tooltip': VBTooltip,
    },
    data() {
        return {
            disabled: true,
            search: "",
            to_id: "",
            from_id: "",
            sellerName: "",
            id: this.$route.params.id,
            loading: false,
            reports: null,
            unknownRequests: null,
            returnedRequests: null,
            soldRequests: null,
            unknown_requests: null,
            filterDate: {
                endDate: "",
                startDate: "",
            },
            editDescription: '',
            currentEditId: null,
            unknownRequestsFields: [
                {
                    key: "row",
                    label: "ردیف",
                },
                {
                    key: "variety_name",
                    label: "عنوان",
                },
                {
                    key: "created_at",
                    label: "زمان ارسال به فروشنده",
                },
                {
                    key: "description",
                    label: "توضیحات",
                },
                {
                    key: "edit_description",
                    label: "ویرایش توضیحات",
                },
            ],
            soldRequestsFields: [
                {
                    key: "row",
                    label: "ردیف",
                },
                {
                    key: "variety_name",
                    label: "عنوان",
                },
                {
                    key: "created_at",
                    label: "زمان ارسال به فروشنده",
                },
                {
                    key: "cashier_name",
                    label: "صندوق دار",
                },
                {
                    key: "sold_at",
                    label: "تاریخ فروش",
                },
            ],
            returnedRequestsFields: [
                {
                    key: "row",
                    label: "ردیف",
                },
                {
                    key: "variety_name",
                    label: "عنوان",
                },
                {
                    key: "created_at",
                    label: "زمان ارسال به فروشنده",
                },
                {
                    key: "returned_at",
                    label: "زمان ارسال به انباردار",
                },
            ],
        };
    },
    created() {
        this.loadData();
        this.sellerName = this.$route.query.seller_name;
    },
    methods: {
        print() {
            window.print();
        },
        doFilter() {
            this.reports = null;
            this.disabled = true;
            this.$route.query.start_date = null;
            this.$route.query.end_date = null;
            this.loadData();
        },
        async loadData() {
            this.loading = true;
            this.reports = null;

            if (this.$route.query.start_date && this.$route.query.end_date) {
                this.filterDate.startDate = this.$route.query.start_date;
                this.filterDate.endDate = this.$route.query.end_date;
            } else {
                const today = new Date();
                const startOfToday = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);

                if (!this.filterDate.startDate || !this.filterDate.endDate) {
                    this.filterDate.startDate = this.formatDate(startOfToday);
                    this.filterDate.endDate = this.formatDate(today);
                }
            }

            try {
                const response = await this.$axios.get("admin/sellers-transaction-reports/detail-by-sellers/" + this.id, {
                    params: {
                        start_date: this.filterDate.startDate,
                        end_date: this.filterDate.endDate,
                    },
                });

                this.reports = response.data.data;
                this.returnedRequests = response.data.data.returned_requests;
                this.soldRequests = response.data.data.sold_requests;
                this.unknownRequests = response.data.data.unknown_requests;
                this.disabled = false;
            } catch (e) {
                this.reports = [];
            }

            this.loading = false;
        },
        openModal(id) {
            this.currentEditId = id;
            this.editDescription = this.unknownRequests.find(item => item.id == id).description;
            $('#editModal').modal('show');
        },
        formatDate(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
        async submitEdit() {
            $('#editModal').modal('hide');
            const data = {
                description: this.editDescription,
            };
            try {
                const response = await this.$axios.post(`admin/seller-requests-update-description/${this.currentEditId}`, data);
                const currentDescription = response.data.data.sellerRequest.description;
                this.unknownRequests.find(item => item.id === response.data.data.sellerRequest.id).description = currentDescription;
                this.$root.notify("توضیحات با موفقیت ذخیره شد.", "success");
            } catch (e) {
                this.$root.notify(e.message || "خطا در ذخیره‌سازی");
            }
        }
    },
    computed: {
    },
};
</script>

<style scoped>
.report-header-box {
    width: 80%;
    margin: 0 auto;
    padding: 20px 40px;
    border-radius: 35px;
    background: linear-gradient(135deg, #e3f2fd, #78a0c191);
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.seller-name {
    font-size: 1.4rem;
    font-weight: 700;
    color: #0d47a1;
}

.date-range {
    display: flex;
    text-align: right;
    line-height: 1.8;
}

.date-label {
    font-weight: 600;
    margin: 0 4px;
    color: #1565c0;
}

.date-value {
    background: #fff;
    padding: 3px 10px;
    border-radius: 8px;
    font-weight: 600;
    color: #0d47a1;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
}

.report-item-card {
    position: relative;
    overflow: hidden;
    width: 300px;
    max-width: 100%;
    padding: 18px 15px;
    border-radius: 16px;
    background: linear-gradient(35deg, #68d18300, #e1ede654);
    border: 1px solid #e5e9f0;
    display: flex;
    margin-bottom: 15px;
    justify-content: space-between;
    align-items: center;
    gap: 13px;
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.05);
}

.report-item-card * {
    position: relative;
    z-index: 1;
}

.report-label {
    font-weight: 600;
    font-size: 15px;
    color: #2b2b2b;
    white-space: nowrap;
}
</style>
<style>
.print-only {
    display: none;
}

@media print {
    .not-in-print {
        display: none !important;
    }

    .app-content .side-app {
        padding: 0 !important;
    }

    body * {
        visibility: hidden;
    }

    .print-only {
        display: flex;
        justify-content: center;
    }

    #print,
    #print * {
        visibility: visible;
        font-size: 1.25rem;
    }

    #print {
        padding: 0 !important;
        width: 100%;
    }

    .mr-2-print {
        margin-right: 20px;
    }
}
</style>